import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend';
import { ImplementationMissingException, sortArray } from '@nu-art/ts-common';
import { DropDown_Precondition, ModuleFE_Action, ModuleFE_OrderGroup } from '../../../../../../_entity.js';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { ModuleFE_Expression } from '@app/hcs-frontend';
import { Editor_PreconditionTimeConstraint } from '../../../../../Page_PathwayEditor/selectors/renderers/renderers-pathway-state/componentes/precondition-editor/Editor_Preconditions.js';
const resolve_PreconditionActionLabel = (precondition) => {
    switch (precondition.itemPointer.dbKey) {
        case DBDef_Action.dbKey:
            return ModuleFE_Action.cache.unique(precondition.itemPointer.id)?.name ?? 'N/A';
        case DBDef_OrderGroup.dbKey:
            return ModuleFE_OrderGroup.cache.unique(precondition.itemPointer.id)?.name ?? 'N/A';
        default:
            throw new ImplementationMissingException(`Sort handling for dbKey ${precondition.itemPointer.dbKey} missing!`);
    }
};
export const Editor_Preconditions_Modules = [ModuleFE_Action, ModuleFE_OrderGroup, ModuleFE_Expression];
export const Editor_Preconditions = (props) => {
    return _jsx(TS_MultiSelect_V2, { className: 'preconditions', disabled: !props.editMode, editable: props.editable, prop: 'preconditions', itemsDirection: 'vertical', getItemKey: (p, idx) => `${p.itemPointer.dbKey}-${p.itemPointer.id}-${p.expressionId ?? 'x'}-${idx}`, sort: (items) => sortArray(items, item => resolve_PreconditionActionLabel(item)), itemRenderer: (precondition, onDelete, disabled, itemIndex, listEditable) => {
            const editablePrecondition = listEditable.editProp(itemIndex, {});
            return _jsxs(_Fragment, { children: [_jsx(Editor_PreconditionTimeConstraint, { editable: editablePrecondition, disabled: disabled }), !disabled && _jsx(ICONS.x.component, { onClick: onDelete })] });
        }, selectionRenderer: (selector) => {
            return _jsx(DropDown_Precondition.selectable, { queryFilter: item => {
                    return selector.existingItems.findIndex(precondition => precondition.itemPointer.id === item.item._id) === -1;
                }, caret: DropDown_DefaultCaret, onSelected: pointer => {
                    selector.onSelected({
                        itemPointer: {
                            dbKey: pointer.dbKey,
                            id: pointer.item._id,
                        }
                    });
                } });
        } });
};
//# sourceMappingURL=Editor_Preconditions.js.map